import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const navLinks = [
    { name: 'Terminal', path: '/' },
    { name: 'Showroom', path: '/showroom' },
    { name: 'Economics', path: '/economics' },
    { name: 'Gateway', path: '/gateway' },
    { name: 'Manifesto', path: '/manifesto' },
    { name: 'Highway', path: '/highway' },
  ];

  return (
    <nav className="fixed top-5 w-full z-50 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800/50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-9 h-9 rounded bg-zinc-900 border border-cyan-500/30 flex items-center justify-center group-hover:box-glow-cyan transition-all">
            <SafeIcon icon={FiIcons.FiCpu} className="text-cyan-400 text-lg" />
          </div>
          <span className="font-bold tracking-widest text-zinc-100 group-hover:text-glow-cyan transition-all">
            BSMC<span className="text-cyan-500">.AUTOS</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`text-xs tracking-widest uppercase transition-all ${
                location.pathname === link.path
                  ? 'text-cyan-400 text-glow-cyan'
                  : 'text-zinc-500 hover:text-zinc-300'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/showroom"
            className="px-5 py-2 bg-amber-500/10 border border-amber-500/50 text-amber-400 text-xs font-bold tracking-widest rounded uppercase hover:bg-amber-500/20 hover:box-glow-amber transition-all flex items-center gap-2"
          >
            <SafeIcon icon={FiIcons.FiTool} />
            Build
          </Link>
        </div>

        <button onClick={() => setOpen(!open)} className="md:hidden text-zinc-400">
          <SafeIcon icon={open ? FiIcons.FiX : FiIcons.FiMenu} className="text-xl" />
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-zinc-950 border-t border-zinc-800 px-6 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              onClick={() => setOpen(false)}
              className="text-xs tracking-widest uppercase text-zinc-400 hover:text-cyan-400"
            >
              {link.name}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}